<template>
    <row v-on:dblclick.native="openModal" v-if="!hide">
        <template slot="type">
            <i class="material-icons">subdirectory_arrow_right</i>
        </template>
        <template slot="date">-</template>
        <template slot="nights">-</template>
        <template slot="name">{{name}}</template>

        <template slot="marginTax">
            <margin-tax v-model="marginTaxEnabled" :tax="marginTax" :margin="grossMargin" />
        </template>

        <template slot="buyPriceCalculation" v-if="showExchangeRates">
            <input-price
                :linked="linked"
                v-model="buyPriceInCalculationCurrency"
            />
        </template>

        <template slot="buyPrice">
            <input-price
                :linked="linked"
                v-model="buyPrice"
                :provider-prices="getProviderPrices(buyPriceType)"
                :currency="currency"
                :is-blue="hasTwoCurrencies"
            />
        </template>

        <template slot="sellPriceCalculation" v-if="showExchangeRates">
            <input-price
                v-model="sellPriceInCalculationCurrency"
            />
        </template>

        <template slot="sellPrice">
            <input-price
                v-model="sellPrice"
                :is-blue="hasTwoCurrencies"
            />
        </template>

        <template slot="profitCalculation" v-if="showExchangeRates">
            <input-price
                v-model="profitInCalculationCurrency"
            />
        </template>

        <template slot="profit">
            <input-price
                v-model="profit"
                :is-blue="hasTwoCurrencies"
            />
        </template>
        <template slot="margin">
            <input-price v-model="margin"/>
        </template>
    </row>
</template>

<script>
import price from './price';

 export default {
    mixins: [ price ],

    props: {
        name: {
            type: String,
        },

        property: {
            type: String,
            required: true
        }
    },

    computed: {
        buyPriceType: function() {  return `${this.property}BuyPrice`; },
        sellPriceType: function() {  return `${this.property}SellPrice`; },

        placeholder: function () { return this.price.placeholder },

        buyPrice: {
            get: function () {
                return this.price[`${this.property}BuyPrice`].amount * this.requestsCurrencyExchange
            },

            set: function (value) {
                this.updatePrice({[`${this.property}BuyPrice`]: {
                        amount: value,
                        currency: this.orderCurrency
                    }})
            }
        },

        sellPrice: {
            get: function () {
                return this.price[`${this.property}SellPrice`].amount
            },

            set: function (value) {
               this.updatePrice({[`${this.property}SellPrice`]: {
                       amount: value,
                       currency: this.orderCurrency
                   }})
            }
        },


    },

    methods: {
        openModal: function() {
            this.$store.commit('updateModalPlaceholder', this.price)
        }
    }
}
</script>
